import { render, staticRenderFns } from "./WarrantyEachHead.vue?vue&type=template&id=47c13a28"
import script from "./WarrantyEachHead.vue?vue&type=script&lang=js"
export * from "./WarrantyEachHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports